import { PuzzleImagePicker } from "../components/games/PuzzleImagePicker.jsx";
import { useRoom } from "../contexts/RoomContext.jsx";
import { PUZZLE_IMAGES } from "../data/puzzleImages.js";

export function PuzzleImageSelectionPage() {
  const { isHost, roomData, escolherImagemQuebraCabeca } = useRoom();

  if (!isHost) {
    return (
      <div className="container-sm text-center puzzle-waiting-page">
        <div className="card">
          <h2 className="title">Aguarde...</h2>
          <div className="spinner puzzle-spinner" aria-hidden="true" />
          <p className="subtitle">
            O host está escolhendo a imagem do Quebra-Cabeça desta rodada...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-sm text-center puzzle-picker-page">
      <h2 className="title">Escolha a imagem!</h2>
      <p className="subtitle mb-40">
        Rodada {roomData?.rodadaAtual || 1} — selecione a imagem que todo mundo
        vai tentar montar.
      </p>
      <div className="card puzzle-picker-card">
        <PuzzleImagePicker
          images={PUZZLE_IMAGES}
          onSelect={(image) => escolherImagemQuebraCabeca(image.url)}
        />
      </div>
    </div>
  );
}
